import {Directive, Input} from "@angular/core";
import {BaseComponent} from "../base-component";
import {Page} from "../models/filter.model";
import {FilterMetadata, SortMeta} from "primeng/api";
import {IdCodeNameQuery} from "../models/base.query";
import {simplifiedRegexSearch} from "../helpers/general-helpers";

@Directive()
export class FilteredComponent extends BaseComponent {
  @Input() public page = new Page();
  @Input() multiSortMeta?: SortMeta[];
  @Input() sortField?: string = 'Code';
  @Input() sortOrder: number = 1;

  @Input() defaultFilter: {
    [s: string]: FilterMetadata | FilterMetadata[];
  } = {};

  searchFn(term: string, item: IdCodeNameQuery): boolean {
    return simplifiedRegexSearch(term, [item.Code, item.Name, item.DisplayName]);
  }
}
